import {Flex, Spacer, Text} from '@chakra-ui/react'
import React from 'react'
import {getColorScore} from '@utils'
import {uniqueId} from 'lodash'

interface IData {
  end_time?: number
  letters?: any[]
  phones?: any[]
  score?: number
  score_raw?: number
  start_time?: number
  word?: string
}
interface IDataProps {
  data: IData[]
}
function CheckedWords({data}: IDataProps) {
  function renderLetters(letters: any) {
    return letters.map((letter: any) => (
      <Text
        key={uniqueId(letter.letter)}
        fontWeight={'600'}
        fontSize={'24px'}
        textDecoration={'underline'}
        color={getColorScore(letter.score * 100)}>
        {letter.letter}
      </Text>
    ))
  }
  return (
    <Flex flexDirection={'row'} flexWrap={'wrap'}>
      {data?.map((item: any, index: number) => (
        <Flex key={uniqueId(item.word)}>
          {renderLetters(item.letters)}
          {index !== data.length - 1 && <Spacer w={'4px'} />}
        </Flex>
      ))}
    </Flex>
  )
}

export default CheckedWords
